import { css } from '@emotion/css'
import { spacing } from '@offerzen/pinata-shame'

const styles = {
  container: css({
    padding: 0,
    marginTop: spacing.medium,
    marginBottom: spacing.medium,
  }),
}

export default styles
